import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  ResetForm: FormGroup;
  error: string = '';
  hint: string = '';
  show: boolean = false;
  showConfirm: boolean = false;
  resetToken: null | undefined;
  email: null | undefined;
  CurrentState: string = 'Verified';
  qParam: any = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((params) => {
      this.resetToken = params.token;
      this.email = params.mail;
      // this.VerifyToken();
    });
    this.ResetForm = new FormGroup({
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20),
      ]),
      confirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20),
      ]),
    });
  }

  ngOnInit(): void {}
  // VerifyToken() {
  //   this.authService
  //     .ValidPasswordToken({ reset_password_token: this.resetToken })
  //     .subscribe(
  //       (data: any) => {
  //         if (data.Response === 'Verified') {
  //           this.CurrentState = 'Verified';
  //         } else {
  //           this.CurrentState = 'NotVerified';
  //         }
  //       },
  //       (err) => {
  //         this.CurrentState = 'NotVerified';
  //       }
  //     );
  // }
  onChange() {
    this.error = '';
  }
  get f() {
    return this.ResetForm.controls;
  }
  onSubmit() {
    if (this.ResetForm.valid) {
      if (
        this.ResetForm.value.password === this.ResetForm.value.confirmPassword
      ) {
        this.qParam['token'] = this.resetToken;
        this.qParam['password'] = this.ResetForm.value.password;
        this.authService
          .ResetPassword(this.qParam['token'], this.qParam['password'])
          .subscribe(
            (result: any) => {
              if (result.Response == 'Data Updated') {
                this.hint = 'Password Successfully updated';
                this.router.navigate(['/login']);
              }
            },
            (error: any) => {
              this.error = 'Something went wrong..Please try again.';
            }
          );
      } else {
        this.error = 'Passwords are not matching!';
      }
    } else {
      this.error = 'Please enter a valid password';
    }
  }
  toggleShow() {
    this.show = !this.show;
  }
  toggleConfirmShow() {
    this.showConfirm = !this.showConfirm;
  }
}
